import { COMMUNITY_TIME_OLD_VALUE } from '../constants';
import { FileTypeE } from './../../models/enums';

/**
 * Returns correct value in case of "Community time" file type ("5" instead of "2")
*/

const getCorrectFileType = (fileType: number) => {
    return fileType === COMMUNITY_TIME_OLD_VALUE ? FileTypeE['Community time'] : fileType;
};

export default getCorrectFileType;